import { useEffect, useState } from 'react'
import Sidebar from '../../(components)/sidebar'
import Content from '../../(components)/content'
import useNav from '../../../../hooks/useNav'
import { DateRange } from 'react-day-picker'
import { addDays, endOfDay, format, isToday, startOfDay } from 'date-fns'
import { useBoundStore } from '../../../../zustand'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from '../../../../context/AuthProvider';
import axios from '../../../../lib/axios';
import { toast } from 'sonner'
import { useLocation, useSearchParams } from 'react-router-dom'
import { isWithinRange } from '../../../../lib/time'
import { useLingui } from '@lingui/react/macro'
import { getCustomSettings } from '../../../../config/custom-settings'

const Dashboard = () => {
  const { t } = useLingui()
  const { auth } = useAuth()
  const { nav, setNav } = useNav()
  const [searchParams, setSearchParams] = useSearchParams();
  const interventions = useBoundStore((state) => state.interventions)
  const setInterventions = useBoundStore((state) => state.setInterventions)

  const [date, setdate] = useState<DateRange | undefined>({from: new Date(), to: addDays(new Date(), 0)});
  
  const [show_all, setshow_all] = useState(false);
  const [task_id, settask_id] = useState<number>(0);  

  function filterInterventions() {
    if(!Array.isArray(interventions)) return []
    let tmp = [...interventions]

		const filterStatus = getCustomSettings(auth.data?.databases[0].dbid)?.intervention?.start_page?.filter_status || []
    tmp = tmp.filter(i => !filterStatus.includes(i.m_iSTATUS))
    tmp = tmp.filter(i => {
      const inRange = isWithinRange(new Date(i.m_dDATUM), startOfDay(date?.from || new Date()), endOfDay(date?.to || new Date()))
      return inRange
    })
        
    return tmp
  }

  function selectIntervention (callid?:string) {
    setNav({...nav, title:t`Startpagina`})

    const urlTaskId = callid ? callid : searchParams.get('callid')
    
    const allInterventions = Array.isArray(interventions) ? interventions : []
    const visibleInterventions = !show_all ? filterInterventions() : allInterventions
    const isInterventionVisible = visibleInterventions.find((i)=>i.m_iCALLID.toString() === (urlTaskId || ''))

    let selectedCallId = ''
    
    if(!urlTaskId){
      if(visibleInterventions?.length > 0) {
        selectedCallId = visibleInterventions[0].m_iCALLID.toString()
      }
    } else {
      if(!(!!isInterventionVisible) && visibleInterventions[0]){
        selectedCallId = visibleInterventions[0].m_iCALLID.toString()
      } else {
        selectedCallId = urlTaskId.toString()
      }
    }

    settask_id(Number(selectedCallId))
    setSearchParams({ callid: selectedCallId })
  }

  useEffect(()=>{
    if(interventions) {
      selectIntervention()
    }
  }, [interventions, searchParams])
  
  const { data:ints, refetch:getInterventions, isError:isErrorInterventions } = useQuery({
    queryKey: [`interventions-${date?.from}-${date?.to}`],
    queryFn: async () => {
      let params:any = { 
        dbid: auth.data?.databases[0].dbid
      }
      if(date?.from) {
        params.fromdate = format(new Date(date.from), 'yyyyMMdd')
      }
      if(date?.to){
        params.todate = format(new Date(date.to), 'yyyyMMdd')
      }
      toast.loading('Interventies ophalen...', { id:'interventions' })
      const { data } = await axios.get(`interventions`, {
        params: params
      })
      toast.dismiss('interventions')
      return data;
    },
    enabled: false
  })

  useEffect(()=>{
    if(ints) {
      setInterventions(ints)
      toast.dismiss('interventions')
    }
  }, [ints])

  useEffect(()=>{
    if(isErrorInterventions){
      toast.error('Geen interventies gevonden', { id:'interventions' })
    }
  }, [isErrorInterventions])

  useEffect(()=>{
    if(date){
      // get interventions again with date between
      getInterventions()
    }
  }, [date])

  return (
    <div className='flex '>

      <Sidebar 
        date={date} 
        task_id={task_id} 
        settask_id={(v)=>{ selectIntervention(v.toString()) }} 
        setdate={(v)=>{setdate(v)}}
        show_all={show_all}
        setshow_all={(v)=>{setshow_all(v)}}
      />

      <Content task_id={task_id}/>
    </div>
  )
}

export default Dashboard